import React from 'react';
import Sidebar from '../components/Sidebar';
import { Scale, ShieldAlert } from 'lucide-react';

const Legal = () => (
  <div className="flex h-screen bg-slate-50/50 font-inter text-blue-900 overflow-hidden">
    <Sidebar />
    <main className="flex-1 p-12 overflow-y-auto">
      <div className="max-w-3xl bg-white p-16 rounded-[3rem] border border-slate-100 shadow-sm relative overflow-hidden">
        <Scale className="absolute -right-8 -top-8 text-slate-50 size-64" />
        
        <header className="relative z-10 mb-12">
          <div className="flex items-center gap-4 mb-4">
            <div className="p-3 bg-blue-900 text-white rounded-2xl shadow-lg">
              <ShieldAlert size={24} />
            </div>
            <h1 className="text-3xl font-black italic uppercase tracking-tighter">
              Legal <span className="text-blue-600">Disclaimer</span>
            </h1>
          </div>
          <p className="text-slate-400 text-xs font-black uppercase tracking-widest">Regulatory Protection & Liability Limitations</p>
        </header>

        <div className="relative z-10 space-y-8">
          <section className="p-8 bg-slate-50 rounded-[2rem] border border-slate-100">
            <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-blue-600 mb-4">No Legal Advice</h2>
            <p className="text-sm font-bold text-slate-600 leading-relaxed uppercase tracking-tight">
              AI Fine Protector™ is a diagnostic risk-analysis engine. The outputs, including "Estimated Regulatory Liability," are mathematical projections based on user-provided data and current regulatory frameworks (EU AI Act, UK White Paper, etc.). This does not constitute professional legal advice or a binding guarantee of compliance.
            </p>
          </section>

          <section className="px-8">
            <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 mb-4">Calculation Methodology</h2>
            <p className="text-xs font-bold text-slate-400 leading-relaxed uppercase tracking-wide">
              Fines are estimated based on statutory maximums and specific gravity factors. Actual regulatory penalties are subject to the discretion of relevant Data Protection Authorities (DPAs) and judicial oversight.
            </p>
          </section>
        </div>
      </div>
    </main>
  </div>
);

export default Legal;